import { useMainStore } from "@/stores/mainStore";
import { listModule } from "@/types/global";
import { useTranslation } from "i18next-vue";
import { computed, ComputedRef, onMounted, Ref, ref, toRaw } from "vue";

export function useModules(
  allowedEdit: boolean,
  slots: Ref<{}>,
  allSlots: Ref<{}>
) {
  const { t } = useTranslation();
  const mainStore = useMainStore();

  onMounted(() => {
    console.log("useModules slots", slots.value);

    for (const module of mainStore.modules) {
      console.log("Im here,", slots.value[module.value]);

      const element: listModule = Object.assign({}, module, {
        slots: slots.value[module.value],
        monthEnd: Math.max(
          0,
          allSlots.value[module.value] - slots.value[module.value]
        )
      });

      if (slots.value[module.value] === undefined) {
        return [];
      }

      initialItems.value.push(element);
    }
  });

  const headers: any = computed(() => {
    return [
      {
        title: t("views.licence.table.module"),
        align: "start",
        sortable: false,
        key: "module",
        value: (item) => t("views.licence.modules." + item.name + ".name"),
        width: "25%"
      },
      {
        title: t("views.licence.table.description"),
        align: "start",
        sortable: false,
        key: "description",
        value: (item) =>
          t("views.licence.modules." + item.name + ".description"),
        width: "25%"
      },
      {
        title: t("views.licence.table.active"),
        key: "active",
        sortable: false,
        width: "25%",
        hidden: !allowedEdit
      },
      {
        title: t("views.licence.table.slots"),
        key: "slots",
        value: (item) => item.slots,
        width: "25%",
        hidden: allowedEdit
      },
      {
        title: t("views.licence.table.price"),
        key: "price",
        sortable: false,
        align: "end",
        value: (item) => {
          console.log(
            item.module,
            item.price,
            Math.floor(item.price) / 100 + " €"
          );
          return Math.floor(item.price) / 100 + " €";
        },
        width: "25%"
      },
      {
        title: t("views.licence.table.total"),
        key: "priceAll",
        sortable: false,
        align: "end",
        value: (item) => {
          console.log(
            item.module,
            item.price,
            Math.floor(item.price) / 100 + " €"
          );
          return Math.floor(item.price * item.slots) / 100 + " €";
        },
        width: "25%"
      }
    ].filter((i) => !i.hidden);
  });

  const initialItems: Ref<listModule[]> = ref([]);
  const items: ComputedRef<listModule[]> = computed(() => {
    const result = [];
    for (const module of mainStore.modules) {
      const element: listModule = Object.assign({}, module, {
        slots: slots.value[module.value],
        monthEnd: Math.max(
          0,
          allSlots.value[module.value] - slots.value[module.value]
        )
      });

      result.push(element);
    }

    return result;
  });

  const oldMonthlyCost = computed(() => {
    return (
      initialItems.value.reduce((acc, module) => {
        acc += module.price * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const monthlyCost = computed(() => {
    return (
      items.value.reduce((acc, module) => {
        acc += module.price * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const modulesAdded = computed(() => {
    console.log("modulesAdded ", toRaw(items.value), toRaw(initialItems.value));
    return Object.fromEntries(
      items.value.map((module, index) => {
        console.log(module, index, initialItems.value[index]);
        return [module.name, module.slots - initialItems.value[index].slots];
      })
    );
  });

  const modulesAddedAdditional = computed(() => {
    return Object.fromEntries(
      items.value.map((module, index) => [
        module.name,
        Math.max(module.slots - allSlots.value[module.value], 0)
      ])
    );
  });

  const modulesRemoved = computed(() => {
    return Object.fromEntries(
      initialItems.value.map((module, index) => [
        module.name,
        module.slots - items.value[index].slots
      ])
    );
  });

  const additionalCharge = computed(() => {
    {
      const now = new Date();
      const monthDays = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0
      ).getDate();
      const remainingDays = monthDays - now.getDate() + 1;
      return {
        remainingDays,
        additionalPrice:
          Math.floor(
            mainStore.modules.reduce((acc, module) => {
              acc += module.price * modulesAddedAdditional.value[module.name];
              return acc;
            }, 0) *
              (remainingDays / monthDays)
          ) / 100,
        addedModules: Object.entries(modulesAdded.value)
          .filter(([_, slots]) => slots > 0)
          .map(([name, _]) => name)
          .join(", ")
      };
    }
    return null;
  });

  return {
    headers,
    initialItems,
    items,
    oldMonthlyCost,
    monthlyCost,
    modulesAdded,
    modulesAddedAdditional,
    modulesRemoved,
    additionalCharge
  };
}
